import { VariantResponse } from './useVariations'

export const getAvailableColours = (
  variants: VariantResponse | undefined,
  selectedSize: string | undefined,
) => {
  if (!variants) return []
  if (!selectedSize) return []

  return variants?.variants
    .filter((variant) => {
      return variant.dimensions[0].value === selectedSize
    })
    .map((x) => {
      return {
        type: x.dimensions[1].type,
        id: x.dimensions[1].id,
        value: x.dimensions[1].value,
      }
    })
}
